import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem('access_token') || '');
  const [userInfo, setUserInfo] = useState(() => {
    const stored = localStorage.getItem('userInfo');
    return stored ? JSON.parse(stored) : null;
  });
  const [locationInfo, setLocationInfo] = useState(() => {
    const stored = localStorage.getItem('locationInfo');
    return stored ? JSON.parse(stored) : null;
  });


  return (
    <UserContext.Provider value={{ authToken, setAuthToken, userInfo, setUserInfo, locationInfo, setLocationInfo }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);